




























import { Component, Vue, Prop } from 'vue-property-decorator';
import EventCardHeader from '@/components/NewsFeed/Components/Partials/Events/EventCardHeader.vue';
import EventCardImage from '@/components/NewsFeed/Components/Partials/Events/EventCardImage.vue';
import EventCardSocials from '@/components/NewsFeed/Components/Partials/Events/EventCardSocials.vue';
import EventCardTexts from '@/components/NewsFeed/Components/Partials/Events/EventCardTexts.vue';
import EventCardActions from '@/components/NewsFeed/Components/Partials/Events/EventCardActions.vue';
import DashboardNotification from '@/ts/instances/notifications/DashboardNotification';

@Component({
    name: 'BroadcastCard',
    components: {
        EventCardHeader,
        EventCardImage,
        EventCardSocials,
        EventCardTexts,
        EventCardActions,
    },
})
export default class BroadcastCard extends Vue {
    @Prop() public notification: DashboardNotification;

    constructor() {
        super();
    }

    public open(payload: any): void {
        this.$router.push({
            name: payload.routeName,
            params: payload.routeParams,
        });
    }
}
